export default {
  state: {
    data: {},
    order: [],
    loading: false,
    error: null,
    queue: [],
    config: {
      default: 'PRODUCT',
      append: '_ROUTE',
      path: 'product/route',
      error: { active: false },
      get: { active: false, msg: '' },
      update: { active: false, msg: 'Seite aktualisiert' },
      create: { active: false, msg: 'Seite erstellt' },
      delete: { active: false, msg: 'Seite gelöscht' },
      admin: {
        error: { active: true },
        get: { active: true, msg: '' },
        update: { active: true, msg: 'Seite aktualisiert' },
        create: { active: true, msg: 'Seite erstellt' },
        delete: { active: true, msg: 'Seite gelöscht' },
      },
    },
    treeModel: [],
  },
  getters: {
    dataByParentId: (state) => (id) => {
      const { routes } = state.data[id] || { routes: [] };
      return routes;
    },
  },
  mutations: {},
  actions: {
    SOCKET_PRODUCT_ROUTES({ dispatch, getters }, payload) {
      if (process.env.NODE_ENV !== 'production') console.log(`[${getters.config.path}] SOCKET_PRODUCT_ROUTES`, payload);
      dispatch('HANDLE_PAYLOAD', payload[1]);

      // for (let i = 0; i < payload[1].length; i += 1) {
      //   const element = payload[1][i];

      //   dispatch('product/GET', element.id);
      //   dispatch('sub/GET', element.id);
      //   dispatch('user/GET', element.id);
      // }

      // commit('SET_LOADING', false);
    },
  },
};
